module.exports = __webpack_public_path__ + "media/1fie-f-santw.642dcb87.mp3";